import { render, staticRenderFns } from "./UsersByLocation.vue?vue&type=template&id=88a2ef08&scoped=true"
import script from "./UsersByLocation.vue?vue&type=script&lang=js"
export * from "./UsersByLocation.vue?vue&type=script&lang=js"
import style0 from "./UsersByLocation.vue?vue&type=style&index=0&id=88a2ef08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a2ef08",
  null
  
)

export default component.exports